/* Little Furry · animaciones de entrada y sombra del encabezado al bajar. */
(function(){
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function marca(){
    var secs = document.querySelectorAll('#MainContent > .shopify-section');
    secs.forEach(function(s, i){
      if (i === 0) return; // la portada arriba entra sin esperar
      if (!s.classList.contains('lf-reveal')) s.classList.add('lf-reveal');
    });
    document.querySelectorAll('.lf-tipos__grid, .lf-etapas__grid, .lf-conf__grid, .product-grid').forEach(function(g){
      g.classList.add('lf-reveal', 'lf-reveal--stagger');
    });
  }
  function observa(){
    if (quieto || !('IntersectionObserver' in window)) { document.querySelectorAll('.lf-reveal').forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.lf-reveal:not(.is-in)').forEach(function(e){ io.observe(e); });
  }
  function scroll(){ document.body.classList.toggle('lf-scrolled', window.scrollY > 12); }
  function arranca(){ marca(); observa(); scroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
  window.addEventListener('scroll', scroll, { passive: true });
  document.addEventListener('shopify:section:load', function(){ marca(); observa(); });
  // lo que entra por navegacion sin recargar (Horizon usa view transitions)
  new MutationObserver(function(){ marca(); observa(); }).observe(document.getElementById('MainContent') || document.body, { childList: true });
})();
